import { IconButton, IconButtonProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { forwardRef, PropsWithChildren } from 'react';

type StyledIconButtonProps = PropsWithChildren<IconButtonProps>;

export const StyledIconButton = forwardRef<
  HTMLButtonElement,
  StyledIconButtonProps
>(function StyledIconButton({ children, ...props }, ref) {
  return (
    <IconButton
      ref={ref}
      {...props}
      sx={[
        {
          flexShrink: 0,
          alignSelf: 'flex-start',
          aspectRatio: '1',
          boxSizing: 'border-box',
          border: (theme) =>
            `2px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          borderRadius: '8px',
          '&:hover': {
            border: (theme) => `2px solid ${theme.palette.primary.main}`,
            backgroundColor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.hoverOpacity,
              ),
            '@media (hover: none)': {
              backgroundColor: 'transparent',
            },
          },
          '&.Mui-disabled': {
            border: (theme) =>
              `1px solid ${theme.palette.action.disabledBackground}`,
          },
          '& .MuiSvgIcon-root': {
            fill: (theme) => theme.palette.primary.main,
          },
          '&.Mui-disabled .MuiSvgIcon-root': {
            fill: (theme) => theme.palette.action.disabled,
          },
        },
      ]}
    >
      {children}
    </IconButton>
  );
});
